import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// components
import MainHeader from "../../components/Header/MainHeader";
import SelectOption from "../../components/Select/SelectOption";
import Loader from "../../components/Loader/Loader";

// methods
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { addGender } from "../../redux/slices/registerSlice";
import { googleEvent_LOJ049 } from "../../lib/google-analytics";
import { googleEvent_LOJ047 } from "../../lib/google-analytics-loan-journey-events";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function Gender() {
  const [loading, setLoading] = useState(false);

  const { gender } = useSelector((state) => state.register);
  const { repeatCustomer } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const { handleStep } = useResponse();

  const { incompleteDetailsUpdate } = new ServicesAPI();

  const data = ["Male", "Female", "Other"];

  const handleIncompleteDetailsUpdateAPI = async (data) => {
    setLoading(true);

    const res = await incompleteDetailsUpdate(data, repeatCustomer);

    if (res) {
      dispatch(addGender(data.value));
      handleStep();
    }

    setLoading(false);
  };

  useEffect(() => {
    googleEvent_LOJ047();
  }, []);

  useEffect(() => {
    loading ? handleShowContextualLoader("Please wait...") : handlehideContextualLoader();
  }, [loading]);

  return (
    <>
      <div className="wrapper">
        <MainHeader title="Personal Info" showProgress={true} percent={7.69} />

        <div className="mb-3">
          <p className="label">Gender</p>
        </div>

        {data.map((item, index) => (
          <div
            key={index}
            onClick={async () => {
              handleIncompleteDetailsUpdateAPI({
                key: "gender",
                value: item,
              });

              // Events
              googleEvent_LOJ049(item, item);
            }}
          >
            <SelectOption name={item} checked={gender} />
          </div>
        ))}
      </div>

    </>
  );
}
